__turbopack_context__.v({
  "className": "notosanssc_5e20744a-module__ngeb-a__className",
  "variable": "notosanssc_5e20744a-module__ngeb-a__variable",
});
